export const homeFaqs = [
  {
    question: "How much does Rinnai air conditioning cost in Perth?",
    answer: "The installed cost depends on the system type, capacity, home layout, electrical requirements, access and, for ducted systems, the number of zones and outlets. A home-specific quote is more reliable than comparing unit-only prices online.",
  },
  {
    question: "Should I choose ducted, split or multi-split air conditioning?",
    answer: "A split system usually suits one main room. Multi-split can serve several rooms from one outdoor unit. Ducted is generally the strongest starting point for discreet whole-home comfort. The right choice depends on how many rooms you use, your budget and the property itself.",
  },
  {
    question: "Can you replace my existing air conditioner with a Rinnai system?",
    answer: "Yes, replacement enquiries are welcome. The existing unit, pipework, ductwork, electrical supply, controls and access should be assessed before confirming what can be retained and what should be upgraded.",
  },
  {
    question: "Do Rinnai systems heat as well as cool?",
    answer: "Applicable Rinnai reverse-cycle systems provide both heating and cooling. Product capability varies by model, so the quoted system should be checked against your year-round comfort needs.",
  },
  {
    question: "Can I control rooms separately or use my phone?",
    answer: "Compatible controls can provide zoning, schedules, remote access and other smart features on applicable systems. Availability depends on the selected product and how the system is configured.",
  },
  {
    question: "Are your air-conditioning installers licensed?",
    answer: "Perth Home Air Conditioning states that its air-conditioning installers are ARC Tick licensed. The team provides residential supply and installation services, with removal requirements confirmed as part of the individual quote.",
  },
  {
    question: "How much local experience does Perth Home Air Conditioning have?",
    answer: "Perth Home Air Conditioning states that it has served the Perth metropolitan area for more than 30 years, supported by the established air-conditioning experience of sister company Langler Air.",
  },
  {
    question: "Do you install across Perth?",
    answer: "Perth Home Air Conditioning provides residential supply and installation across metropolitan Perth. Share your suburb or postcode in the quote form so the team can confirm service availability for your address.",
  },
];

export const choosingFaqs = [
  {
    question: "Should I choose ducted, split or multi-split air conditioning?",
    answer: "A split system usually suits one main room. Multi-split serves several rooms from one shared outdoor unit. Ducted is the strongest option for discreet whole-home comfort. The right choice depends on how many rooms you use, your budget and the property itself.",
  },
  {
    question: "I only need one room cooled. What should I choose?",
    answer: "A Rinnai inverter split system is usually the most cost-effective choice for a single bedroom, living area or home office. It heats and cools, installs more simply than ducted and lets you control that room independently.",
  },
  {
    question: "What is multi-split air conditioning?",
    answer: "A Rinnai multi-split connects several indoor units to one outdoor unit. Each room can be controlled independently, and you avoid covering the outside of your home with multiple condensers.",
  },
  {
    question: "Can you replace my existing air conditioner with a Rinnai system?",
    answer: "Yes. We assess the existing unit, pipework, ductwork, electrical supply, controls and access, then confirm what can be retained and what should be upgraded before quoting.",
  },
];

export const ductedFaqs = [
  {
    question: "What size Rinnai ducted system do I need?",
    answer: "It depends on total floor area, ceiling height, insulation, glazing, orientation and climate zone. Rinnai ducted systems range from 7kW to 24kW, and the correct capacity is confirmed with a whole-of-home heat load calculation rather than a rule of thumb. Oversized systems waste energy, while undersized systems struggle on hot Perth afternoons.",
  },
  {
    question: "Can Rinnai ducted air conditioning heat as well as cool?",
    answer: "Yes. Rinnai ducted systems are reverse cycle, so one system cools in summer and heats in winter. Rinnai rates a typical output of around 3kW of heating or cooling for every 1kW of electricity used, and notes that reverse cycle ducted heating is often cheaper to run than traditional gas heating.",
  },
  {
    question: "Can ducted air conditioning be installed in an existing home?",
    answer: "Usually, yes. Rinnai ducted systems suit both new builds and existing homes. Retrofits need enough roof or ceiling space for the indoor unit and ductwork. The splittable 15kW, 18kW, 20kW and 24kW indoor units can be carried into tight roof spaces in sections. We confirm access during the site assessment.",
  },
  {
    question: "How many zones can a Rinnai ducted system have?",
    answer: "The Rinnai Home Controller manages up to 8 individual zones using a touchscreen controller and wireless room sensors. If you want more zones or wider smart-home control, a compatible iZone system can manage up to 14 zones.",
  },
  {
    question: "How long does a ducted air conditioning system last?",
    answer: "With correct installation and regular maintenance, Rinnai indicates 12 to 20 years is typical. Ductwork often lasts longer than the mechanical components, which can make future replacement simpler.",
  },
  {
    question: "Is ducted air conditioning more expensive than split systems?",
    answer: "The upfront cost is higher because one system serves the whole home and includes ductwork, outlets and zoning. For homes that need several rooms conditioned, ducted is often the cleaner, quieter long-term solution. Running costs depend on home size, insulation, zoning and how you use it.",
  },
];

export const splitFaqs = [
  {
    question: "What size split system do I need for a bedroom?",
    answer: "Most bedrooms suit a 2.5kW to 3.5kW system. As a guide, the Rinnai TX Series 2.5kW model suits about 11-17m² and the 3.5kW model about 16-23m², based on insulated ceilings up to 2.6m. West-facing rooms and large windows may need more capacity.",
  },
  {
    question: "What size split system do I need for a living area?",
    answer: "Living areas typically need 5.0kW to 7.0kW, and large open-plan spaces 8.0kW or more. The TX Series 7.0kW model suits about 32-47m². Ceiling height, glazing and afternoon sun all matter, so we confirm the size on site.",
  },
  {
    question: "Are Rinnai split systems energy efficient?",
    answer: "Yes. Inverter split systems are among the most efficient ways to heat and cool a room because they adjust output instead of switching on and off. Compare the average climate zone on the Zoned Energy Rating Label, which includes Perth. Selected Rinnai series reach up to 9 stars.",
  },
  {
    question: "Can a split system heat my home in winter?",
    answer: "Yes. Reverse cycle split systems move heat rather than create it, which makes them cheaper to run than many traditional electric heaters. The Rinnai TX Series is designed to heat in outdoor temperatures down to -15°C.",
  },
  {
    question: "What is GoldGuard, and does it matter in Perth?",
    answer: "GoldGuard is a protective coating on the Rinnai TX Series outdoor condenser coil. It increases resistance to oxidation and corrosion compared with standard coils, which is valuable in coastal suburbs exposed to salt air. It also helps speed up defrosting in heating mode.",
  },
  {
    question: "Can I control a Rinnai split system from my phone?",
    answer: "Yes. The TX Series has built-in Wi-Fi. Using the NetHome Plus app you can switch it on or off, set the temperature and adjust fan speed from anywhere, and it works with compatible Google Assistant and Amazon Alexa devices.",
  },
];

export const izoneFaqs = [
  {
    question: "What is iZone?",
    answer: "iZone is a smart control system for ducted air conditioning. Touchscreen controllers and wireless sensors measure the temperature in each zone and adjust airflow automatically. It can also expand into lighting, irrigation, power monitoring and other smart-home functions.",
  },
  {
    question: "Does iZone work with Rinnai ducted air conditioning?",
    answer: "iZone has been part of Rinnai Australia since October 2023, and iZone controls are designed for compatible ducted air conditioning designs. Compatibility, zone numbers and controller choice are confirmed for your specific system before you commit.",
  },
  {
    question: "Can iZone be added to an existing ducted system?",
    answer: "In many cases, yes. iZone is designed to make ducted systems smarter, including existing installations. We check your current indoor unit, ductwork, zone dampers and Wi-Fi setup to confirm what is possible.",
  },
  {
    question: "How many zones can iZone control?",
    answer: "iZone climate control systems can manage up to 14 zones, with wireless sensors and up to 12 touchscreen controllers on supported systems. Bedrooms, living areas and studies can each hold their own temperature.",
  },
  {
    question: "Does iZone work with Google Home, Alexa and Siri?",
    answer: "Yes. iZone works with Google Home and Amazon Alexa. Apple HomeKit and Siri control require a system with iZone’s newer open connection bridge, so we confirm this before purchase.",
  },
  {
    question: "Will iZone lower my running costs?",
    answer: "iZone sends heating and cooling only where and when it is needed, and features such as fan auto control and occupancy sensing reduce waste. Actual savings depend on your home, insulation and how you use the system.",
  },
];

export const rinnaiFaqs = [
  {
    question: "Who makes Rinnai air conditioners?",
    answer: "Rinnai air conditioners are supplied by Rinnai Australia, a subsidiary of Japan’s Rinnai Corporation. Rinnai has supplied Australian homes with heating, cooling and hot water products for more than 50 years. Its group also includes Brivis, APAC and iZone.",
  },
  {
    question: "What warranty do Rinnai air conditioners have?",
    answer: "Rinnai offers a 7 year warranty on eligible split system and ducted air conditioning products. Terms and conditions apply, so we confirm the warranty for the exact model in your quote.",
  },
  {
    question: "Who services Rinnai air conditioners?",
    answer: "1stCare is Rinnai’s national service network. Qualified technicians service Rinnai Group products using genuine spare parts. Service, repair and warranty assessments run 8:30am to 5:00pm AEST, Monday to Friday, excluding public holidays.",
  },
  {
    question: "Is Rinnai suitable for Perth’s climate?",
    answer: "Yes. Rinnai designs its air conditioning for Australian conditions. Rinnai ducted systems are built to operate from -20°C to +50°C outdoors, and split systems carry Zoned Energy Rating Labels showing performance in the average climate zone, which includes Perth.",
  },
  {
    question: "Does Rinnai own iZone?",
    answer: "Yes. Rinnai Australia acquired iZone, a Western Australian developer of smart home and ducted air conditioning controls, in October 2023.",
  },
  {
    question: "Is Perth Home Air Conditioning part of Rinnai?",
    answer: "No. Perth Home Air Conditioning is an independent Perth business that specialises in supplying and installing Rinnai air conditioning. Rinnai Australia manufactures and supplies the products and administers the product warranty.",
  },
];

export const costFaqs = [
  {
    question: "How much does Rinnai air conditioning cost in Perth?",
    answer: "The installed cost depends on the system type, capacity, home layout, electrical requirements, access and, for ducted systems, the number of zones and outlets. A home-specific quote is more reliable than comparing unit-only prices online.",
  },
  {
    question: "What affects air conditioning running costs?",
    answer: "Running costs depend on correct sizing, insulation, glazing, the system’s energy rating, how many rooms you condition and your temperature settings. A correctly sized inverter system that only conditions occupied zones costs less to run.",
  },
  {
    question: "Does zoning really save energy?",
    answer: "Yes, when used well. Zoning lets a ducted system condition only the rooms you are using, so it moves less air and works less hard. Rinnai Home Controller and iZone both add zone control, with iZone offering up to 14 zones.",
  },
  {
    question: "Are there ongoing maintenance costs?",
    answer: "Rinnai recommends following the service maintenance schedule for your product and carrying out routine user maintenance such as filter cleaning. Regular care keeps the system efficient and supports long-term reliability.",
  },
];

export const aboutFaqs = [
  {
    question: "Are your installers licensed?",
    answer: "Yes. Perth Home Air Conditioning uses ARC Tick licensed air conditioning installers.",
  },
  {
    question: "How long have you been operating in Perth?",
    answer: "Perth Home Air Conditioning has served homes across the Perth metropolitan area for more than 30 years.",
  },
  {
    question: "What is your relationship with Langler Air?",
    answer: "Perth Home Air Conditioning is the sister company of Langler Air, an established Perth air conditioning business. The two share local experience, while Perth Home Air Conditioning focuses on Rinnai residential systems.",
  },
  {
    question: "Do you remove my old air conditioner?",
    answer: "Yes. Supply, installation and removal of the old system can be included. What is removed, and how, is confirmed in your written quote.",
  },
  {
    question: "Which areas do you service?",
    answer: "We install across the Perth metropolitan area, including the northern, southern, eastern and western suburbs and the Perth Hills. Enter your suburb or postcode in the quote form and we will confirm availability.",
  },
  {
    question: "What happens after I request a quote?",
    answer: "A specialist calls to understand your home, rooms and priorities. Where needed we assess the property and calculate the heat load, then provide a clear written quote showing the recommended Rinnai system and what is included.",
  },
];

export const faqCategories = [
  {
    id: "faq-choosing",
    title: "Choosing the right system",
    intro: "Not sure where to start? These answers help you narrow down split, multi-split and ducted options.",
    items: choosingFaqs,
  },
  {
    id: "faq-ducted",
    title: "Rinnai ducted air conditioning",
    intro: "Sizing, zoning, heating, retrofits and lifespan for whole-home Rinnai ducted systems.",
    items: ductedFaqs,
  },
  {
    id: "faq-split",
    title: "Rinnai split systems",
    intro: "Room sizing, efficiency, winter heating and smart control for Rinnai inverter split systems.",
    items: splitFaqs,
  },
  {
    id: "faq-izone",
    title: "iZone smart control",
    intro: "How iZone works with ducted systems, how many zones it controls and what it connects to.",
    items: izoneFaqs,
  },
  {
    id: "faq-rinnai",
    title: "Rinnai brand, warranty and service",
    intro: "Who makes Rinnai, what the warranty covers and who services your system.",
    items: rinnaiFaqs,
  },
  {
    id: "faq-costs",
    title: "Costs and running costs",
    intro: "What drives the installed price and the ongoing cost of running your system.",
    items: costFaqs,
  },
  {
    id: "faq-about",
    title: "About Perth Home Air Conditioning",
    intro: "Licensing, experience, service area and what happens after you enquire.",
    items: aboutFaqs,
  },
];
